import {Component, HostBinding, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {SvgIconComponent} from "angular-svg-icon";
import {style} from "@angular/animations";

@Component({
  selector: 'app-x-button',
  standalone: true,
  imports: [NgIf, SvgIconComponent],
  templateUrl: './x-button.component.html',
  styleUrl: './x-button.component.less',
})
export class XButtonComponent {
  @Input() size: '24' | '32' | '28' = '24';
  @Input() style: 'filled' | 'outlined' | 'destructive' | 'outlined-black' | 'outlined-orange' | 'outlined-red' | 'filled-black' = 'filled';
  @Input() loadingIconColor: string = '#18A0FB';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;

  @HostBinding('class') get class() {
    return `size-${this.size} style-${this.style} ${this.disabled ? 'disabled' : ''}`;
  }
}
